<div *ngIf="selectedAccount" class="flex-fill center-content active-account-container">
  <p class="active-account-desc">Currently viewing AWS Trusted Advisor for this account:</p>
  <p [matMenuTriggerFor]="menu" class="active-account" [class.blur-text]="blurHelper.enableBlur">{{ selectedAccount }} <span class="material-icons">
      expand_more
    </span>
  </p>

  <mat-menu class="accounts-menu" #menu="matMenu" (closed)="resetSearch()">
    <mat-form-field class="search-field" (click)="$event.stopPropagation()">
      <input matInput [(ngModel)]="searchValue" placeholder="Enter account name" autocomplete="off">
      <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear" (click)="resetSearch()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <ng-container *ngTemplateOutlet="accountsTemplate;context:{accountsList: commonService?.accountsSubject | async | filter:'Name':searchValue}"></ng-container>
    
    <ng-template #accountsTemplate let-list="accountsList">
      <button *ngFor="let account of list" (click)="selectAccount(account)" mat-flat-button>
        <span [class.blur-text]="blurHelper.enableBlur">{{account?.Name}}</span>
      </button>
      <small *ngIf="list?.length === 0">No accounts were found...</small>
    </ng-template>
  </mat-menu>
</div>